module.exports = __webpack_public_path__ + "media/images/landing/ar/manage-8daee08eae0823177289b1e240db6b31.png";